import React, { useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import swal from 'sweetalert';
import {
  Button, Box, Card, CardContent, FormControlLabel, Checkbox,
  Grid, Typography, TextField, InputLabel, MenuItem, FormControl, Select, FormGroup
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
const AddEvents = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [allModules, setAllModules] = useState([]);
  const [formData, setFormData] = useState({
    event: "",
    user_id: "",
    modules: []
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      modules: checked
        ? [...prev.modules, value]
        : prev.modules.filter(module => module !== value)
    }));
  };

  const addEventForUser = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.get('/sanctum/csrf-cookie');
      const res = await axios.post('api/superadmin-storeEvent', formData);

      if (res.data.status === 200) {
        history.push('/master/event');
        swal("Success", res.data.message, "success");
      } else {
        swal("Error", "All fields are required!", "error");
      }
    } catch (error) {
      swal("Error", "Something went wrong!", "error");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, modulesRes] = await Promise.all([
          axios.get('api/superadmin-alluser'),
          axios.get('api/superadmin-allmodules')
        ]);

        if (usersRes.status === 200) setUserList(usersRes.data.users);
        if (modulesRes.status === 200) setAllModules(modulesRes.data.modules);
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
      <Box sx={{ color: '#000000', marginTop: '5%' }}>
        <h4 style={{ marginBottom: '20px' }}>
          <Button
            sx={{
              float: 'right',
              marginTop: '2%',
              ":hover": { color: "white" }
            }}
            color='success'
            size='small'
            variant='contained'
            component={Link}
            to="/master/events"
          >
            Back
          </Button>
        </h4>
        <Card sx={{ width: '60vw' }}>
          <CardContent>
            <Typography component="h1" variant="h5">
              Add Event
            </Typography>
            <Box component="form" onSubmit={addEventForUser} noValidate sx={{ mt: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    required
                    fullWidth
                    label="Event Name"
                    name="event"
                    value={formData.event}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>Select User</InputLabel>
                    <Select
                      name="user_id"
                      value={formData.user_id}
                      onChange={handleInputChange}
                      label="Select User"
                    >
                      {userList.map(item => (
                        <MenuItem value={item.id} key={item.id}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Avatar sx={{ width: 32, height: 32 }}>
                              {item.name.charAt(0).toUpperCase()}
                            </Avatar>
                            <Box>
                              <Typography variant="subtitle2">{item.name}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {item.email}
                              </Typography>
                            </Box>
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    Select Modules:
                  </Typography>
                  <FormGroup row>
                    {allModules.map(item => (
                      <FormControlLabel
                        key={item.id}
                        control={
                          <Checkbox
                            checked={formData.modules.includes(item.id.toString())}
                            onChange={handleCheckboxChange}
                            value={item.id}
                            name="modules"
                          />
                        }
                        label={item.module}
                      />
                    ))}
                  </FormGroup>
                </Grid>
              </Grid>
              <Grid container justifyContent="flex-end">
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  sx={{ mt: 3, mb: 2 }}
                >
                  {loading ? 'Adding...' : 'Add Event'}
                </Button>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
};

export default AddEvents;